// extracted by mini-css-extract-plugin
module.exports = {"list":"service-card-list_list__2bCUf"};